<template>
  <span v-if="hasWarning" class="expired-indicator-dot"></span>
</template>

<script>
  import expiredIndicatorItem from '@/common/mixins/expiredIndicatorItem';

  export default {
    name: 'ExpiredIndicatorDot',
    mixins: [expiredIndicatorItem],
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/colors.scss';

  .expired-indicator-dot {
    flex-shrink: 0;
    align-self: flex-start;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: $red;
    margin-top: 6px;
  }
</style>
